import React from "react";
import LazyLoad from 'react-lazyload';

export default function HomeTestimonial(props) {
    const { header, image, detail } = props.data;
    return (
        <div className="home-testimonial-section section-gap-large">
            <div className="container">
                <blockquote>
                    <h6>
                        {header}
                    </h6>
                    <div className="blockquote-author d-flex align-v-center">
                        <div className="blockquote-image">
                            <LazyLoad>
                                <img src={image} alt="Madison Palermo - Product Delivery" title="Madison Palermo - Product Delivery" />
                            </LazyLoad>
                        </div>
                        <div className="blockquote-detail">
                            {detail}
                        </div>
                    </div>
                </blockquote>
            </div>
        </div>
    );
}
